export default {
  path: 'content',
  name: 'product/content',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "product-show-content" */ './ContentTab')
}
